"use strict";

var _slicedToArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SRGBColor = void 0;

var HSLColor_1 = require("./HSLColor");

var RGBColor_1 = require("./RGBColor");
/**
 * Represents the sRGB color space.
 */


var SRGBColor = /*#__PURE__*/function () {
  /**
   * Creates new RGBColor
   * @param r - Red component in the range [0, 1].
   * @param g - Green component in the range [0, 1].
   * @param b - Blue component in the range [0, 1].
   */
  function SRGBColor(r, g, b) {
    _classCallCheck(this, SRGBColor);

    this.values = [r, g, b];
  }
  /**
   * Parses the hex-string representation of the RGB color.
   * @param hex - Color string in the format "#RGB" (#RGBA) or "#RRGGBB" (#RRGGBBAA).
   * @remarks Alpha value (if present) is ignored.
   */


  _createClass(SRGBColor, [{
    key: "isValidColor",

    /**
     * Checks if the color values are in the range [0, 1].
     */
    value: function isValidColor() {
      return this.r >= 0 && this.r <= 1 && this.g >= 0 && this.g <= 1 && this.b >= 0 && this.b <= 1;
    }
    /**
     * Truncates the color values to the range [0, 1].
     */

  }, {
    key: "truncate",
    value: function truncate() {
      return new SRGBColor(Math.min(1, Math.max(0, this.r)), Math.min(1, Math.max(0, this.g)), Math.min(1, Math.max(0, this.b)));
    }
    /**
     * Return a copy of color values in array format as [r, g, b].
     */

  }, {
    key: "toArray",
    value: function toArray() {
      // copy
      return this.values.map(function (v) {
        return v;
      });
    }
    /**
     * Composes the CSS color string using the rgb() or rgba() format.
     * @param alpha - The alpha value for rgba() format.
     */

  }, {
    key: "toCSSString",
    value: function toCSSString(alpha) {
      var _this$to = this.to255(),
          _this$to2 = _slicedToArray(_this$to, 3),
          r = _this$to2[0],
          g = _this$to2[1],
          b = _this$to2[2];

      if (alpha !== undefined) {
        // cast to [0, 1]
        alpha = Math.min(1, Math.max(0, alpha));
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
      } else {
        return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
      }
    }
    /**
     * Composes the CSS color string using the "#RRGGBB" or "#RRGGBBAA" format.
     * @param alpha - The alpha value for the #RRGGBBAA format.
     */

  }, {
    key: "toHex",
    value: function toHex(alpha) {
      var _this$toFF = this.toFF(),
          _this$toFF2 = _slicedToArray(_this$toFF, 3),
          r = _this$toFF2[0],
          g = _this$toFF2[1],
          b = _this$toFF2[2];

      if (alpha !== undefined) {
        // cast to [0, 1]
        alpha = Math.min(1, Math.max(0, alpha));
        var alphaFF = Math.round(alpha * 255).toString(16);
        return "#".concat(r).concat(g).concat(b).concat(alphaFF);
      } else {
        return "#".concat(r).concat(g).concat(b);
      }
    }
    /**
     * Trasforms color to the HSL format.
     */

  }, {
    key: "toHSL",
    value: function toHSL() {
      var _this$values = _slicedToArray(this.values, 3),
          r = _this$values[0],
          g = _this$values[1],
          b = _this$values[2];

      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h;
      var s;
      var l = (max + min) / 2;

      if (max === min) {
        h = 0;
        s = 0;
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return new HSLColor_1.HSLColor(h, s, l);
    }
    /**
     * Trasforms color to the XYZ format.
     */

  }, {
    key: "toXYZ",
    value: function toXYZ() {
      return this.toRGB().toXYZ();
    }
    /**
     * Convert sRGB-color values into linear RGB format
     */

  }, {
    key: "toRGB",
    value: function toRGB() {
      var _this$values$map = this.values.map(function (v) {
        if (v < 0.04045) {
          return v / 12.92;
        } else {
          return Math.pow((v + 0.055) / 1.055, 2.4);
        }
      }),
          _this$values$map2 = _slicedToArray(_this$values$map, 3),
          r = _this$values$map2[0],
          g = _this$values$map2[1],
          b = _this$values$map2[2];

      return new RGBColor_1.RGBColor(r, g, b);
    }
    /**
     * Trasforms color to the CIE LAB format.
     */

  }, {
    key: "toLAB",
    value: function toLAB() {
      return this.toRGB().toXYZ().toLAB();
    }
    /**
     * Internal helper function to map color values into [0, 255] range.
     */

  }, {
    key: "to255",
    value: function to255() {
      var rgb = this.truncate();
      return rgb.values.map(function (v) {
        return Math.round(255 * v);
      });
    }
    /**
     * Internal helper function to map color values into hex-format "FF".
     */

  }, {
    key: "toFF",
    value: function toFF() {
      var rgb = this.truncate();
      return rgb.values.map(function (v) {
        return Math.round(255 * v).toString(16).padStart(2, "0");
      });
    }
  }, {
    key: "r",

    /**
     * The red-component of the color.
     */
    get: function get() {
      return this.values[0];
    }
    /**
     * The green-component of the color.
     */

  }, {
    key: "g",
    get: function get() {
      return this.values[1];
    }
    /**
     * The blue-component of the color.
     */

  }, {
    key: "b",
    get: function get() {
      return this.values[2];
    }
  }], [{
    key: "ParseHex",
    value: function ParseHex(hex) {
      var isValidColor = /#([a-f0-9]{3,4}){1,2}\b/i.test(hex);

      if (!isValidColor) {
        throw new Error("Invalid CSS RGB color: ".concat(hex));
      }

      var r;
      var g;
      var b;

      if (hex.length === 7 || hex.length === 9) {
        r = parseInt(hex.substring(1, 3), 16) / 255;
        g = parseInt(hex.substring(3, 5), 16) / 255;
        b = parseInt(hex.substring(5, 7), 16) / 255;
      } else if (hex.length === 4 || hex.length === 5) {
        r = parseInt(hex.charAt(1), 16) / 16;
        g = parseInt(hex.charAt(2), 16) / 16;
        b = parseInt(hex.charAt(3), 16) / 16;
      }

      return new SRGBColor(r, g, b);
    }
  }]);

  return SRGBColor;
}();

exports.SRGBColor = SRGBColor;